import { SingleEntityDataAdapter, SingleEntityState } from './types';

export const getSingleEntityDataAdapter = <T>(
  initialState: SingleEntityState<T>,
): SingleEntityDataAdapter<T> => ({
  save: (state, data) => ({
    ...state,
    data: data,
  }),
  update: (state, data) => ({
    ...state,
    data: {
      ...state.data!,
      ...data,
    },
  }),
  reset: () => initialState,
});
